import { Component, Input, OnInit } from '@angular/core';
import { Observable, of } from 'rxjs';
import { BrickDefinitionState } from '../../../../store/dashboard/brick-wall/brick-definition/brick-definition.state';
import { Store } from '@ngxs/store';
import { BrickDefinition } from '../../../../samwebDescription/samweb/brickDefinition';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import { faPlus } from '@fortawesome/pro-solid-svg-icons';
import { AddNewBrickToWallAction } from '../../../../store/dashboard/brick-wall/brick-instances/brick-instances.actions';
import { BrickLayoutType } from '../../../../samwebDescription/samweb/dashboard/brickLayoutType';
import { BrickLocationType } from 'src/app/samwebDescription/samweb/brickLocationType';
import { map } from 'rxjs/operators';
import { GridsterService } from 'src/app/services/gridster/gridster.service';
import _ from 'lodash';
import { BrickInstancesSelectors } from 'src/app/store/dashboard/brick-wall/brick-instances/brick-instances.selectors';

@Component({
   selector: 'samweb-brick-definition-item',
   templateUrl: './brick-definition-item.component.html',
   styleUrls: ['./brick-definition-item.component.scss'],
})
export class BrickDefinitionItemComponent implements OnInit {
   public plusIcon: IconDefinition = faPlus;

   public brickDefinition$: Observable<BrickDefinition>;
   public allowedInBrickWall$: Observable<boolean>;
   public allowedInPilotPanel$: Observable<boolean>;
   public isAddingBrickPossibleInBrickWall$: Observable<boolean>;
   public isAddingBrickPossibleInPilotPanel$: Observable<boolean>;
   public isAddingBrickPossibleSpecial$: Observable<boolean>;

   @Input()
   public addingBrickSpecialHandlingByOtherBrickInstanceId: string;

   constructor(private store: Store, private gridsterService: GridsterService) {}

   @Input()
   public brickDefinitionId: string;

   ngOnInit(): void {
      this.brickDefinition$ = this.store.select(BrickDefinitionState.brickDefinitionByIdFn).pipe(map((fn) => fn(this.brickDefinitionId)));
      this.allowedInBrickWall$ = this.brickDefinition$.pipe(map((definition) => definition.allowedBrickLocation !== BrickLocationType.PILOTPANEL));
      this.allowedInPilotPanel$ = this.brickDefinition$.pipe(map((definition) => definition.allowedBrickLocation !== BrickLocationType.BRICKWALL));
      this.isAddingBrickPossibleInBrickWall$ = this.gridsterService.isAddingBrickPossible$(false, this.brickDefinitionId);
      this.isAddingBrickPossibleInPilotPanel$ = this.gridsterService.isAddingBrickPossible$(true, this.brickDefinitionId);
      if (!_.isEmpty(this.addingBrickSpecialHandlingByOtherBrickInstanceId)) {
         const brickDefinition = this.store.selectSnapshot(BrickInstancesSelectors.brickDescriptionFn)(this.addingBrickSpecialHandlingByOtherBrickInstanceId)
            ?.definition;
         if (brickDefinition?.brickDefinitionId === 'tabBrick') {
            this.isAddingBrickPossibleSpecial$ = of(true);
         } else {
            this.isAddingBrickPossibleSpecial$ = this.gridsterService.isAddingBrickPossible$(
               this.addingBrickSpecialHandlingByOtherBrickInstanceId,
               this.brickDefinitionId
            );
         }
      }
   }

   addBrickToBrickWall(isInPilotPanel: boolean) {
      this.store.dispatch(new AddNewBrickToWallAction(this.brickDefinitionId, isInPilotPanel ? BrickLayoutType.PILOT_PANEL : BrickLayoutType.DEFAULT_WALL));
   }

   addBrickToBrickWallByLayoutBrick(layoutBrickInstanceId: string) {
      this.store.dispatch(new AddNewBrickToWallAction(this.brickDefinitionId, BrickLayoutType.IN_LAYOUT_BRICK, layoutBrickInstanceId));
   }
}
